import { AdTypeEnum } from './util';

const customStyleByAdType = {
  [AdTypeEnum.MMA]: {
    placementContainer: {
      position: 'unset',
    },
    placementWrapper: {
      top: '45%',
    },
  },
  [AdTypeEnum.MSAN]: {
    placementContainer: {
      position: 'relative',
    },
    placementWrapper: {
      top: '47%',
    },
  },
  [AdTypeEnum.MSANV2]: {
    placementContainer: {
      position: 'relative',
    },
    placementWrapper: {
      top: '47%',
    },
  },
  [AdTypeEnum.pMax]: {
    placementContainer: {
      position: 'unset',
    },
    placementWrapper: {
      top: '45%',
    },
  },
  [AdTypeEnum.Boost]: {
    placementContainer: {
      position: 'relative',
    },
    placementWrapper: {
      top: '47%',
    },
  },
  [AdTypeEnum.NewBoost]: {
    placementContainer: {
      position: 'relative',
    },
    placementWrapper: {
      top: '47%',
    },
  },
  [AdTypeEnum.LinkedIn]: {
    placementContainer: {
      position: 'relative',
    },
    placementWrapper: {
      top: '45%',
    },
  },
};

export const getPlacementContainerStyle = adType => () => ({
  previewPlacementContainer: {
    height: 500,
    overflow: 'hidden',
    position: customStyleByAdType[adType].placementContainer.position,
    '& .outlook-text-web': {
      marginTop: 25,
    },
    '& .responsive-1x1-msan, .responsive-133x100-msan': {
      width: '100%',
      padding: '0 20px',
    },
  },
  placementWrapper: {
    position: 'absolute',
    top: customStyleByAdType[adType].placementWrapper.top,
    left: '50%',
    transform: 'translate(-50%,-50%)',
  },
  previewTypeString: {
    position: 'absolute',
    bottom: 50,
    fontSize: 14,
    lineHeight: '20px',
    paddingTop: 12,
    width: '100%',
    textAlign: 'center',
  },
  additionalDisclaimer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    textAlign: 'left',
    fontSize: 12,
    lineHeight: '20px',
    padding: '0 48px',
  },
});

export const getPreviewCarouselStyle = () => ({
  unifiedCarouselLayoutWrapper: {
    width: '100%',
    border: '1px solid #C8C8C8',
    margin: 0,
    position: 'relative',
    minWidth: 0,
    background: '#ffffff',

    '& .preview-header': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',

      '& .ad-preview-title': {
        margin: '20px 24px 16px 24px',
        fontSize: 18,
        fontWeight: 'normal',
        lineHeight: '24px',
        display: 'inline-block',
        flexGrow: 0,
      },

      '& .flex-grow': {
        flexGrow: 1,
      },
    },

    '& .disclaimer-info': {
      padding: '0 24px 20px 24px',

      '& .disclaimer-info-inline': {
        fontSize: 12,
        textAlign: 'left',
        lineHeight: '20px',
      },
    },
  },

  customCarouselClassname: {
    '& .carousel-indicators': {
      left: '44px !important',
      marginLeft: 0,
      bottom: 10,
    },
    '& a.carousel-control.left': {
      left: 0,
      bottom: -7,
      marginLeft: 15,
    },
    '& a.carousel-control.right': {
      bottom: -7,
    },
  },
});
